import React from 'react';
import ReactDOM from 'react-dom/client';
import {migrateSessionCookie} from "./hooks/useSessionCookie";
import reportWebVitals from './reportWebVitals';
import {CssVarsProvider} from "@mui/joy/styles";
import glassTheme from "./theme";
import {RouterProvider} from "react-router-dom";
import {GlobalStyles} from "@mui/joy";
import FeedbackContext from "./context/FeedbackContext";
import ApiServiceContext from "./context/ApiServiceContext";
import AuthContext from "./context/AuthContext";
import {CookiesProvider} from "react-cookie";
import regularTheme from "./theme.regular";
import ThemeContext from "./context/ThemeContext";
import SubscriptionContext from "./context/SubscriptionContext";
import {appHost, productionMode} from "./utils/routes";
import {appRouter, devRouter, guestRouter} from "./router";
import LanguageContext from "./context/LanguageContext";
import "./localization/index"
import './index.css';
import NotificationContext from "./context/NotificationContext";

// if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
//     const script = document.createElement("script")
//     script.src = "https://cdn.jsdelivr.net/npm/eruda"
//     document.head.appendChild(script)
//     script.onload = () => (window as any).eruda.init()
// }

// Move a pre-sharing session cookie onto the shared domain before anything reads it.
migrateSessionCookie()

const root = ReactDOM.createRoot(document.getElementById('root'))
const themeFileMapper = {
    glass: glassTheme,
    light: regularTheme,
    dark: regularTheme,
}
root.render(
    <CookiesProvider defaultSetOptions={{path: '/'}}>
        <LanguageContext>
            <ThemeContext>
                <FeedbackContext>
                    <ApiServiceContext>
                        <NotificationContext>
                            <CssVarsProvider
                                theme={themeFileMapper[localStorage.getItem("linguascore-theme") || "light"]}
                                defaultMode={"light"}>
                                    <AuthContext>
                                        <React.StrictMode>
                                            <GlobalStyles styles={{
                                                "& .lucide": {
                                                    color: "var(--Icon-color,inherit)",
                                                    margin: "var(--Icon-margin)",
                                                    fontSize: "var(--Icon-fontSize, 20px)",
                                                    width: "0.85em",
                                                    height: "0.85em"
                                                }
                                            }}/>

                                            <RouterProvider
                                                router={productionMode ? appHost ? appRouter : guestRouter : devRouter}/>
                                        </React.StrictMode>

                                    </AuthContext>
                            </CssVarsProvider>
                        </NotificationContext>
                    </ApiServiceContext>
                </FeedbackContext>
            </ThemeContext>
        </LanguageContext>
    </CookiesProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
